'use strict';
//Resize top of navigation menu in mobile
window.addEventListener('load', resizeTop);
window.addEventListener('resize', resizeTop);

function resizeTop() {
    let elemHeight = document.getElementById('header').offsetHeight;
    document.getElementById('nav-wrapper').style.top = elemHeight - 3 + 'px';
}

class NavigationMenu {
    constructor(menuButtonId, navWrapperId, dropdownClass, mainContentClass, closeMegaMenu) {
        this.menuButton = document.getElementById(menuButtonId);
        this.navWrapper = document.getElementById(navWrapperId);
        this.dropdownClass = dropdownClass;
        this.mainContent = document.querySelector(mainContentClass);
        this.closeMenuButton = document.querySelector(closeMegaMenu);
        this.initMenuToggle();
        this.initDropdowns();
        this.initCloseOnClickOutside();
        this.initCloseMegaMenu();
    }

    initMenuToggle() {
        this.menuButton.addEventListener('click', () => {
            this.navWrapper.classList.toggle('show');
            this.menuButton.classList.toggle('open');
            this.updateMenuButtonText();
        });
    }

    updateMenuButtonText() {
        if (this.menuButton.classList.contains('open')) {
            this.menuButton.innerHTML = '<span>Close&nbsp;</span><i class="fa fa-times"></i>';
        } else {
            this.menuButton.innerHTML = '<span>Menu&nbsp;</span><i class="fa fa-bars"></i>';
        }
    }

    initDropdowns() {
        const navButtons = document.getElementsByClassName('nav-button');
        Array.from(navButtons).forEach(button => {
            button.addEventListener('click', (event) => this.toggleDropdown(event));
        });
    }

    toggleDropdown(event) {
        const button = event.currentTarget;
        const submenuId = button.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);
        const dropdowns = document.getElementsByClassName(this.dropdownClass);

        Array.from(dropdowns).forEach(dropdown => {
            if (dropdown.classList.contains('open') && dropdown.id !== submenuId) {
                dropdown.classList.remove('open');
                dropdown.previousElementSibling.setAttribute('aria-expanded', 'false');
            }
        });

        submenu.classList.toggle('open');
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    }

    initCloseOnClickOutside() {
        this.mainContent.addEventListener('click', () => {
            const dropdowns = document.getElementsByClassName(this.dropdownClass);
            Array.from(dropdowns).forEach(dropdown => {
                if (dropdown.classList.contains('open')) {
                    dropdown.classList.remove('open');
                    dropdown.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }

    initCloseMegaMenu() {
        this.closeMenuButton.addEventListener('click', () => {
            let grandparent = this.closeMenuButton.parentNode.parentNode;
            grandparent.classList.remove('open');
            const navButton = grandparent.previousElementSibling;
            navButton.setAttribute('aria-expanded', 'false');
            navButton.focus();
        });
    }
}

// Initialize the NavigationMenu class once DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
    new NavigationMenu('menuBtn', 'nav-wrapper', 'dropdown', '.main.worx', '.close-megamenu');
    document.getElementById('skip-content-link').addEventListener('click', function() {
        document.getElementById('content').focus();
    });
});


// Keyboard Support for ADA

document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        // Get the currently shown dropdown
        let shownDropdown = document.querySelector('.dropdown.open');

        if (shownDropdown) {
            // Get the deepest dropdown (the last dropdown with the class 'active-nav')
            let deepestDropdown = shownDropdown;

            // Find the previous dropdown, if any
            let previousDropdown = deepestDropdown.closest('.dropdown.open');
            if (!previousDropdown) {
                previousDropdown = deepestDropdown.previousElementSibling;
            }

            // Close the deepest dropdown first
            deepestDropdown.classList.remove('open');
            deepestDropdown.previousElementSibling.setAttribute('aria-expanded', 'false');
            deepestDropdown.previousElementSibling.focus(); // Put focus back on the parent button

            // Close the previous dropdown
            if (previousDropdown) { // If there is a previous dropdown
                previousDropdown.classList.remove('open');
                previousDropdown.setAttribute('aria-expanded', 'false');
                previousDropdown.focus(); // Put focus back on the parent button
            }
        }
    }
});

